import React from 'react';
import { useTimer } from 'react-timer-hook';

import clsx from 'clsx';

import styles from './CountdownTimer.module.css';

export enum CountdownTimerType {
  INFO = 'info',
  WARNING = 'warning',
}

interface CountdownTimerProps {
  expiryTimestamp: Date;
  onComplete?: () => void;
  type?: CountdownTimerType;
  description?: string;
  className?: string;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  expiryTimestamp,
  onComplete,
  type = CountdownTimerType.INFO,
  className = '',
  description,
}) => {
  // Convert expiryTimestamp (ms) to Date
  const expiryDate = new Date(expiryTimestamp);

  const { seconds, minutes } = useTimer({
    expiryTimestamp: expiryDate,
    onExpire: onComplete,
  });

  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div
        className={
          type === CountdownTimerType.INFO ? styles.loaderBorder : styles.loaderBorderWarning
        }
      />
      <div className={styles.container}>
        <div
          className={clsx(
            styles.countdownTimer,
            type === CountdownTimerType.INFO && styles.info,
            type === CountdownTimerType.WARNING && styles.warning,
            className,
          )}
        >
          <span className="w-[2ch]">{formattedMinutes}</span>
          <span className="px-1">:</span>
          <span className="w-[2ch]">{formattedSeconds}</span>
        </div>
        {description && (
          <p className="mb-3 mt-1 text-center text-sm font-normal leading-3 text-white lg:text-base lg:leading-5">
            {description}
          </p>
        )}
      </div>
      <div className="h-[1px] w-full bg-loader-border" />
    </div>
  );
};
